<template>
  <sui-page>
    <sui-page-header :pageId="contextPageId" />
    <sui-page-contents>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_BBS_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">
              {{ bbsName }}
            </div>
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CATG')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">
              {{ bbsCatgGrpItemName }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TITLE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">
              {{ noticeTitle }}
            </div>
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RGST_USR')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <cmp-user-name-link
              :pageId="contextPageId"
              :displayType="'1'"
              :displayLanguageId="isDisplayLanguageId"
              :knoxId="isKnoxId"
              :userId="isUserId"
              :loginId="isLoginId"
              :userName="isUserName"
              :userGlobalName="isUserGlobalName"
              :departmentName="isDepartmentName"
              :departmentEnglishName="isDepartmentEnglishName"
              :type="'link'"
            />
          </div>
        </div>
      </div>
      <div class="mrB10" />
      <div
        v-if="bbsTypeCode === 'N'"
        ref="viewerArea"
        class="scr_box"
        style="height:250px"
      />
      <sui-web-editor
        v-if="bbsTypeCode !== 'N'"
        ref="myEditor"
        :isViewer="true"
        @loaded="retrieveDetails"
      />
      <div class="mrB10" />
      <cmp-file-attacher
        ref="fileAttacher"
        :pageId="contextPageId"
        :showAddDeleteBtn="false"
        :showUpDownArrowBtn="false"
        :showDDRegion="false"
        :attachGroupId="'ATG_CLB_BBS_COMMON'"
        :attachDocumentId="attachDocumentId"
      />
    </sui-page-contents>
    <sui-page-footer>
      <div class="comm_btn_wrap">
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onClose"
        >
          {{ $t('MSG_BTN_CLOSE') }}
        </sui-button>
        <sui-button
          v-permission:delete="contextPageId"
          type="button"
          class="comm_btn_solid"
          @click="onDeleteClick"
        >
          {{ $t('MSG_BTN_DEL') }}
        </sui-button>
      </div>
    </sui-page-footer>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CLB_00033', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    closePagePopup: {
      type: Function,
      default: () => {},
    },
    pageInitialData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isWebEdtrInitialized: false,
      bbsName: '',
      bbsId: '',
      postIdParam: '',
      bbsTypeCode: '',
      attachDocumentId: '',
      noticeTitle: '',
      registrantName: '',
      effectiveDate: '',
      bbsCatgGrpItemName: '',
      urgnCheck: false,
      annCheck: false,
      showMetauserBtn: true,
      registeredUserName: '',
      usrId: '',
      viewer: 'dattata',
      noticeObjTextContent: '',
      isDisplayLanguageId: '',
      isKnoxId: '',
      isUserId: '',
      isLoginId: '',
      isUserName: '',
      isUserGlobalName: '',
      isDepartmentName: '',
      isDepartmentEnglishName: '',
    };
  },
  computed: {},
  watch: {},
  datasets: [],
  beforeMount() {},
  mounted() {
    this.postIdParam = this.pageInitialData.postIdParam;
    this.bbsTypeCode = this.pageInitialData.bbsTypeCode;
    this.retrieveDetails().then(() => {
      this.isWebEdtrInitialized = true;
    }).catch(() => {
      this.isWebEdtrInitialized = true;
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    retrieveDetails() {
      const dataParam = {
        bbsTypeCode: this.pageInitialData.bbsTypeCode,
      };
      this.bbsId = this.pageInitialData.bbsId;
      return new Promise((resolve, reject) => {
        const pathParam = {
          'post-id': this.pageInitialData.postIdParam,
        };
        http.request(this.contextPageId, 'DTS_CLB_00067', {
          path: pathParam,
          query: dataParam,
        }).then(res => {
          this.bbsId = res.data.bbsId;
          this.bbsName = res.data.bbsName;
          this.noticeTitle = res.data.noticoobjTitle;
          if (this.bbsTypeCode === 'N') {
            this.$refs.viewerArea.innerHTML = res.data.noticoobjContent;
          } else {
            // this.noticeObjTextContent = res.data.noticoobjContent;
            this.$refs.myEditor.setHtml(res.data.noticoobjContent);
          }
          this.bbsCatgGrpItemName = res.data.bbsCategoryItemNm;
          this.registeredUserName = res.data.registrantName;
          this.usrId = res.data.usrId;
          this.attachDocumentId = res.data.atthDocId;
          this.isDisplayLanguageId = res.data.displayLanguageId;
          this.isKnoxId = res.data.knoxId;
          this.isUserId = res.data.userId;
          this.isLoginId = res.data.loginId;
          this.isUserName = res.data.userName;
          this.isUserGlobalName = res.data.userGlobalName;
          this.isDepartmentName = res.data.departmentName;
          this.isDepartmentEnglishName = res.data.departmentEnglishName;
          resolve(res);
        }).catch(err => {
          reject(err);
        });
      });
    },
    onCancel() {
      this.closePagePopup(true);
    },
    onClose() {
      this.closePagePopup(false);
    },
    onDeleteClick() {
      const noticoobjUid = [];
      noticoobjUid.push({
        noticoobjUid: this.pageInitialData.postIdParam,
        bbsId: this.pageInitialData.bbsId,
      });
      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_DEL'), null, () => {
        // http.requestTest('delete', `/api/v1/common/email/${emailUid}`, {
        http.request(this.contextPageId, 'DTS_CLB_00068', {
          data: noticoobjUid,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_DELETED'));
          this.onCancel();
        });
      });
      return true;
    },
  },
};
</script>
<style scoped>
</style>
